import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import {
  appendClientSupportMessageToCache,
  CHAT_UNREAD_QUERY_KEY,
  getActiveAdminChatUserId,
} from '../chat-cache';
import { useClientSupportChatSocket } from '../hooks/useClientSupportChatSocket';
import { showSupportChatIncomingToast } from '../support-chat-toast';

type ClientSupportChatToastListenerProps = {
  enabled?: boolean;
};

/** Тосты о сообщениях клиентов и продавцов. */
export function ClientSupportChatToastListener({
  enabled = true,
}: ClientSupportChatToastListenerProps) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  useClientSupportChatSocket(
    {
      onMessage: ({ userId, userName, userPhone, message }) => {
        if (message.senderKind !== 'CLIENT' && message.senderKind !== 'SELLER') {
          return;
        }
        appendClientSupportMessageToCache(queryClient, userId, message, {
          userName,
          userPhone,
        });
        if (getActiveAdminChatUserId() === userId) return;
        const title =
          message.senderKind === 'SELLER'
            ? message.senderName?.trim()
              ? `Продавец · ${message.senderName.trim()}`
              : 'Продавец'
            : 'Сообщение в поддержку - клиент';
        showSupportChatIncomingToast({
          title,
          body: message.body,
          imageCount: message.imageUrls?.length ?? 0,
          messageId: message.id,
          onOpen: () => navigate(`/clients/support-chat?userId=${userId}`),
        });
      },
      onUnread: ({ scope, count, userId }) => {
        if (scope !== 'admin') return;
        if (userId != null && getActiveAdminChatUserId() === userId) return;
        queryClient.setQueryData(CHAT_UNREAD_QUERY_KEY, { count });
      },
    },
    enabled,
  );

  return null;
}
